import * as React from "react";
import * as ReactDOM from "react-dom";

import { checkValidCookie } from "./loginWorker";
import { LogError } from "../actions/errorWorker";
import Logo from "../components/Logo";
import Login from "../components/login";
import EntitySelection from "../components/EntitySelection";
import SearchResults from "../components/SearchResults";
import NoteProperties from "../components/NoteProperties";
import ActiveTaskProperties from "../components/ActiveTaskProperties";
import NewTaskProperties from "../components/NewTaskProperties";
import SuccessMessage from "../components/SuccessMessage";
import ErrorMessage from "../components/ErrorMessage";
import ErrorMessageOnPage from "../components/ErrorMessageOnPage";
import Summary from "../components/Summary";
import LoadOverlay from "../components/LoadOverlay";
import ExistingDocNote from "../components/ExistingDocNote";
import RefreshFields from "../components/RefreshFields";
import Splash from "../components/Splash";
import QueueConfirmation from "../components/QueueConfirmation";
import { get_activetask_props } from "../actions/activetasksWorker";
import { FindDocNotes } from "../actions/FilerWorker";
import {
	formatURL,
	getXplanURL,
	APICalls,
	getXplanCookie,
	IsOverlayShown,
	setConfig,
	setAxiosDefaults,
	clearLogin,
	validateSiteUrl,
	getQueryParams,
} from "./helper";
import { getCustomURLS } from "../actions/backgroundWorker";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { AppConfig } from "../types";
import { errorMessage } from "../../msal-auth/msal-config";
import { getAccessToken } from "../../msal-auth/auth";
import { initializeCacheClearing } from "../actions/cacheWorker";
import { getQueuedEmails } from "../actions/queueWorker";

export function failed_login(error: string, logout = false) {
	clearLogin();
	if (error) {
		LogError(error, null, "failed_login", "ERROR");
	}

	if (logout) {
		location.reload();
		const tfaCookie =localStorage.getItem("tfa_cookie");
		localStorage.clear();
		if (tfaCookie) localStorage.setItem("tfa_cookie", tfaCookie);
	} else {
		renderLogo(false, true);
		renderExistingDocNote(true, null);
		renderEntityCriteria(true);
		renderSearchResults(true, "");
		renderNoteProperties(true);
		renderNewTaskProperties(true);
		renderActiveTaskProperties(true);
		renderSummary(true);
		renderErrorMessage(true, "", "", "");
		renderErrorMessageOnPage(true, "");
		toggleLoading(false);
		renderLogin(false, false, error);
		renderSuccessMessage(true, "", "", "");
	}

	localStorage.removeItem("entity_note_type_results");
	localStorage.removeItem("entity_note_subtype_results");
	localStorage.removeItem("task_taskkind_results");
	localStorage.removeItem("task_subtype_results");
	localStorage.removeItem("task_status_results");
	localStorage.removeItem("xplan_ufield_expire");
	localStorage.removeItem("entity_note_subtype_depend_results");
	localStorage.removeItem("task_subtype_depend_results");
	sessionStorage.clear();
}

export function renderLogin(hide, logged_in, error = "", IsTFA = false) {
	const url = getXplanURL() || "";
	if (hide !== true) {
		clearLogin();
	}
	if (hide === null) {
		ReactDOM.render(<Login xplan_url={url} />, document.getElementById("Login"));
	} else {
		ReactDOM.render(
			<Login xplan_url={url} hide={hide} logged_in={logged_in} error={error} IsTFA={IsTFA} />,
			document.getElementById("Login")
		);
	}
}

function renderEntityCriteria(hide) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("SearchCriteria"));
	} else {
		ReactDOM.render(<EntitySelection hide={hide} />, document.getElementById("SearchCriteria"));
	}
}

function renderSearchResults(hide, data) {
	if (hide || data.length === 0) {
		ReactDOM.unmountComponentAtNode(document.getElementById("SearchResults"));
	} else {
		ReactDOM.render(
			<SearchResults hide={hide} data={data} />,
			document.getElementById("SearchResults")
		);
	}
}

function renderActiveTaskProperties(hide) {
	get_activetask_props(hide);
}

function renderNewTaskProperties(hide) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("NewTaskProperties"));
	} else {
		ReactDOM.render(
			<NewTaskProperties hide={hide} data={[]} />,
			document.getElementById("NewTaskProperties")
		);
	}
}

export function renderNoteProperties(hide) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("NoteProperties"));
	} else {
		ReactDOM.render(<NoteProperties hide={hide} />, document.getElementById("NoteProperties"));
	}
}

export function renderActiveTaskScreen(data, hide) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("ActiveTaskProperties"));
	} else {
		ReactDOM.render(
			<ActiveTaskProperties hide={hide} data={data} />,
			document.getElementById("ActiveTaskProperties")
		);
	}
}

function renderSuccessMessage(hide, link, linkTitle, message) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("SuccessMessage"));
	} else {
		ReactDOM.render(
			<SuccessMessage hide={hide} link={link} linkTitle={linkTitle} message={message} />,
			document.getElementById("SuccessMessage")
		);
	}
}

function renderErrorMessage(
	hide: boolean,
	link: string,
	linkTitle: string,
	message: string,
	options?: {
		hideTitle: boolean;
		hideRetry: boolean;
		backTitle: string;
	}
) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("ErrorMessage"));
	} else {
		ReactDOM.render(
			<ErrorMessage
				hide={hide}
				link={link}
				linkTitle={linkTitle}
				message={message}
				options={options}
			/>,
			document.getElementById("ErrorMessage")
		);
	}
}

function renderErrorMessageOnPage(hide, message) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("ErrorMessageOnPage"));
	} else {
		ReactDOM.render(
			<ErrorMessageOnPage hide={hide} error={message} />,
			document.getElementById("ErrorMessageOnPage")
		);
	}
}

function renderSummary(hide) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("Summary"));
	} else {
		ReactDOM.render(<Summary hide={hide} />, document.getElementById("Summary"));
	}
}

function renderQueueConfirmation(hide, onConfirm, onCancel) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("QueueConfirmation"));
	} else {
		ReactDOM.render(<QueueConfirmation hide={hide} onConfirm={onConfirm} onCancel={onCancel} />, document.getElementById("QueueConfirmation"));
	}
}

export function renderLogo(hide: boolean, login = false) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("Logo"));
	} else {
		ReactDOM.render(<Logo hide={hide} login={login} />, document.getElementById("Logo"));
	}
}

export function handleFileQueueClick() {
	// When user clicks "File Queue", show the entity selection screen
	// but set a flag to indicate we're filing the queue
	sessionStorage.setItem("filing_mode", "queue");
	renderLogo(false);
	renderLogin(true, true);
	renderExistingDocNote(true, null);
	renderEntityCriteria(false);
	renderSearchResults(true, "");
	renderNoteProperties(true);
	renderNewTaskProperties(true);
	renderActiveTaskProperties(true);
	renderSummary(true);
	renderErrorMessage(true, "", "", "");
	renderErrorMessageOnPage(true, "");
	renderSuccessMessage(true, "", "", "");
	toggleLoading(false);
}

export function renderSplash(hide: boolean) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("Logo"));
	} else {
		ReactDOM.render(<Splash />, document.getElementById("Logo"));
	}
}

function renderLoading(hide, message?: string) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("loadPlaceholder"));
	} else {
		ReactDOM.render(<LoadOverlay hide={hide} message={message} />, document.getElementById("loadPlaceholder"));
	}
}

function renderExistingDocNote(hide, data) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("ExistingDocNote"));
	} else {
		ReactDOM.render(
			<ExistingDocNote hide={hide} data={data} />,
			document.getElementById("ExistingDocNote")
		);
	}
}

export function renderRefreshFields(hide) {
	if (hide) {
		ReactDOM.unmountComponentAtNode(document.getElementById("RefreshFields"));
	} else {
		ReactDOM.render(<RefreshFields />, document.getElementById("RefreshFields"));
	}
}

//call before long task and then when you are rendering screen
export function toggleLoading(show: boolean, message?: string) {
	if (show === true) renderLoading(false, message);
	else if (show === false) renderLoading(true, message);
	else if (IsOverlayShown()) renderLoading(false, message);
	else renderLoading(true, message);
}

export async function start(config: AppConfig) {
	// Initialize cache clearing on app startup
	await initializeCacheClearing();
	
	// Check for hide_url_for parameter in URL (used by sideloaded manifests for special clients)
	// This allows manifests like manifest_sanlam_*.xml to override the Xplan URL
	const params_obj = getQueryParams();
	if (params_obj.hide_url_for) {
		localStorage.setItem("hide_url_for", params_obj.hide_url_for.toString());
	} else {
		localStorage.removeItem("hide_url_for");
	}
	
	toggleLoading(true, "Loading..."); // Show loading overlay during startup
	setConfig(config);
	setAxiosDefaults();

	const url = getXplanURL() + APICalls.User;
	const xplan_cookie = getXplanCookie() || "";
	const refresh_token = localStorage.getItem("refresh_token");
	
	// Check for SSO session with refresh token
	if (validateSiteUrl(url, false) && refresh_token) {
		if (process.env.NODE_ENV === "development") {
			console.log("[Session Check] SSO session detected, checking token validity");
		}
		const { shouldRefreshToken, refreshAccessToken, startTokenRefreshTimer } = await import("../actions/helper");
		
		// Check if token needs refresh on startup
		if (shouldRefreshToken()) {
			if (process.env.NODE_ENV === "development") {
				console.log("[Session Check] Token expired or expiring, attempting refresh");
			}
			const success = await refreshAccessToken();
			
			if (success) {
				if (process.env.NODE_ENV === "development") {
					console.log("[Session Check] Token refreshed successfully, proceeding to check session");
				}
				await check_valid_cookie(formatURL(url), true);
				startTokenRefreshTimer();
			} else {
				if (process.env.NODE_ENV === "development") {
					console.error("[Session Check] Token refresh failed, clearing session");
				}
				const { clearLogin } = await import("../actions/helper");
				clearLogin();
				toggleLoading(false);
				renderLogo(false, true);
				renderLogin(null, true);
			}
		} else {
			if (process.env.NODE_ENV === "development") {
				console.log("[Session Check] Token still valid, proceeding to check session");
			}
			await check_valid_cookie(formatURL(url), true);
			startTokenRefreshTimer();
		}
	} else if (validateSiteUrl(url, false) && xplan_cookie !== "") {
		await check_valid_cookie(formatURL(url), true);
	} else {
		localStorage.removeItem("xplan_cookie");
		localStorage.removeItem("xplan_cookie_expire");
		toggleLoading(false);
		renderLogo(false, true);
		renderLogin(null, true);
	}
}

export async function check_valid_cookie(url, showLoading: boolean = true) {
	await checkValidCookie(url, showLoading);
}

export function handleEmailHistory() {
	/* get email history from xplan filer*/
	FindDocNotes();
}

export function existingDocNoteScreen(data) {
	/*render existing docnotes*/
	renderLogo(false);
	renderLogin(true, true);
	renderEntityCriteria(true);
	renderExistingDocNote(false, data);
}

	export async function ExistingCheck() {
	let message = errorMessage;
	const accessToken = await getAccessToken().catch((error) => {
		message = error.message;
		toggleLoading(false, 'Loading...');
		LogError(error, {}, "ExistingCheck", "ERROR");
	});

	if (!accessToken) {
		clearLogin();
		toggleLoading(false);
		renderErrorMessageOnPage(false, message);
		return;
	}

	// Clear all filing-related session storage to start fresh
	sessionStorage.removeItem('task_assignee');
	sessionStorage.removeItem('task_type');
	sessionStorage.removeItem('task_subtype');
	sessionStorage.removeItem('task_status');
	sessionStorage.removeItem('subject');
	sessionStorage.removeItem('selected_clients');
	sessionStorage.removeItem('selected_active_tasks');
	sessionStorage.removeItem('file_to_type');
	sessionStorage.removeItem('exclude_email_from_note');
	sessionStorage.removeItem('custom_note_body');
	sessionStorage.removeItem('note_date');

	toggleLoading(true);
	renderLogo(false);
	renderLogin(true, true);
	renderEntityCriteria(true);
	renderErrorMessageOnPage(true, "");
	renderErrorMessage(true, "", "", "");
	renderSuccessMessage(true, "", "", "");
	
	// Load custom URLs in background without blocking
	getCustomURLS();
	
	renderSearchResults(true, []);
	handleEmailHistory();
	
	// Load ufields in background if needed (non-blocking)
	if (localStorage.getItem("ufields_need_loading") === "true") {
		import("../actions/loginWorker").then(({ GetUfieldData }) => {
			GetUfieldData(true);
		});
	}
	
	toggleLoading(false);
	
	// Start token refresh timer for SSO sessions
	const { startTokenRefreshTimer } = await import("../actions/helper");
	if (localStorage.getItem("refresh_token")) {
		startTokenRefreshTimer();
	}
}

export async function entityCriteriaScreen(backwards) {
	// Ensure ufields are loaded before showing the screen
	if (localStorage.getItem("ufields_need_loading") === "true") {
		toggleLoading(true, "Loading field options...");
		const { ensureUfieldsLoaded } = await import("./loginWorker");
		await ensureUfieldsLoaded();
		toggleLoading(false);
	}
	
	renderLogo(false);
	renderLogin(true, true);
	if (backwards) {
		renderSearchResults(true, []);
	}
	renderEntityCriteria(false);
	renderErrorMessageOnPage(true, "");
	renderErrorMessage(true, "", "", "");
	renderSuccessMessage(true, "", "", "");
	renderExistingDocNote(true, null);
}

export function entityResultsScreen(backwards, data) {
	renderLogo(false);
	if (backwards) {
		renderEntityCriteria(false);
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
	}
	renderSearchResults(true, []);
	renderSearchResults(false, data);
	renderErrorMessageOnPage(true, "");
	toggleLoading(false);
}

export function fileToTypeScreen(backwards) {
	renderLogo(false);
	renderSearchResults(true, []);
	renderEntityCriteria(true);
	if (backwards) {
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
		renderSummary(true);
	} else {
		const file_to_type = JSON.parse(sessionStorage.getItem("file_to_type")) || {};
		if (file_to_type.id === "note") {
			renderNoteProperties(false);
			toggleLoading(false);
		} else if (file_to_type.id === "activetask") {
			renderActiveTaskProperties(false);
		} else if (file_to_type.id === "newtask") {
			renderNewTaskProperties(false);
			toggleLoading(false);
		} else {
			toggleLoading(false);
		}
	}
	renderErrorMessageOnPage(true, "");
	renderSuccessMessage(true, "", "", "");
}

export function notesScreen(backwards) {
	if (backwards) {
		renderSummary(true);
		renderEntityCriteria(false);
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
	} else {
		renderNoteProperties(false);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
	}
	renderErrorMessageOnPage(true, "");
	toggleLoading(false);
}

export function activeTaskScreen(backwards) {
	if (backwards) {
		renderSummary(true);
		renderEntityCriteria(false);
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
	} else {
		renderNoteProperties(true);
		renderActiveTaskProperties(false);
		renderNewTaskProperties(true);
	}
	renderErrorMessageOnPage(true, "");
}

export function newTaskScreen(backwards) {
	if (backwards) {
		renderSummary(true);
		renderEntityCriteria(false);
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
	} else {
		renderNewTaskProperties(false);
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
	}
	renderErrorMessageOnPage(true, "");
	toggleLoading(false);
}

export function successScreen(hide, link, link_title, message) {
	renderLogo(false);
	renderSummary(true);
	renderEntityCriteria(true);
	renderSuccessMessage(hide, link, link_title, message);
	renderErrorMessage(true, "", "", "");
	renderErrorMessageOnPage(true, "");
	renderExistingDocNote(true, null);
	toggleLoading(false);
}

export function errorScreen(
	hide: boolean,
	link: string,
	link_title: string,
	message: string,
	options?: {
		hideTitle: boolean;
		hideRetry: boolean;
		backTitle: string;
	}
) {
	renderLogo(false);
	renderSummary(true);
	renderExistingDocNote(true, null);
	renderErrorMessage(hide, link, link_title, message, options);
	renderSuccessMessage(true, "", "", "");
	renderErrorMessageOnPage(true, "");
	toggleLoading(false);
}

export function summaryScreen() {
	console.log("=== summaryScreen() called ===");
	
	// Hide loading overlay FIRST before checking for confirmation
	toggleLoading(false);
	
	// Check if there are queued emails - if so, ask for confirmation before showing summary
	const queuedEmails = getQueuedEmails();
	console.log("Queued emails count:", queuedEmails.length);
	if (queuedEmails.length > 0) {
		console.log("Showing queue confirmation screen");
		// Show confirmation screen instead of summary
		renderLogo(false);
		renderEntityCriteria(true);
		renderNoteProperties(true);
		renderActiveTaskProperties(true);
		renderNewTaskProperties(true);
		renderSummary(true);
		renderErrorMessage(true, "", "", "");
		renderErrorMessageOnPage(true, "");
		// Explicitly hide loading overlay before showing confirmation
		toggleLoading(false);
		renderQueueConfirmation(false, 
			() => {
				// On confirm - proceed to summary
				console.log("User confirmed batch filing");
				proceedToSummaryScreen();
			},
			() => {
				// On cancel - go back to the appropriate properties screen
				console.log("User cancelled batch filing");
				renderQueueConfirmation(true, null, null);
				
				// Navigate back based on file_to_type
				const file_to_type = JSON.parse(sessionStorage.getItem('file_to_type') || '{"id":"note"}');
				if (file_to_type.id === 'note') {
					notesScreen(true);
				} else if (file_to_type.id === 'activetask') {
					activeTaskScreen(true);
				} else if (file_to_type.id === 'newtask') {
					newTaskScreen(true);
				} else {
					fileToTypeScreen(true);
				}
			}
		);
		return;
	}
	
	// No queued emails - proceed directly to summary
	console.log("No queued emails, proceeding to summary");
	proceedToSummaryScreen();
}

function proceedToSummaryScreen() {
	console.log("Rendering summary screen components...");
	renderLogo(false);
	renderEntityCriteria(true);
	renderNoteProperties(true);
	renderActiveTaskProperties(true);
	renderNewTaskProperties(true);
	renderQueueConfirmation(true, null, null);
	renderSummary(false);
	renderErrorMessage(true, "", "", "");
	renderErrorMessageOnPage(true, "");
	console.log("=== summaryScreen() complete ===");
}

export function throwError(message) {
	// Hide loading overlay first, then show error
	toggleLoading(false);
	// Small delay to ensure loading is hidden before showing error dialog
	setTimeout(() => {
		renderErrorMessageOnPage(false, message);
	}, 10);
}

export function clearError() {
	renderErrorMessageOnPage(true, null);
	// Only reload for critical errors, not for validation errors
	// Validation errors are just dismissed without reloading
}

export function clearErrorAndReload() {
	renderErrorMessageOnPage(true, null);
	// Reload the add-in to reset state cleanly (only for critical errors)
	window.location.reload();
}

export function RefreshFieldsScreen() {
	renderLogo(false);
	renderEntityCriteria(true);
	renderSearchResults(true, []);
	renderNoteProperties(true);
	renderActiveTaskProperties(true);
	renderNewTaskProperties(true);
	renderSummary(true);
	renderErrorMessage(true, "", "", "");
	renderErrorMessageOnPage(true, "");
	renderSuccessMessage(true, null, null, null);
	renderExistingDocNote(true, null);
	renderRefreshFields(false);
	toggleLoading(false);
}

export function ShowDone(closeButtonClick) {
	ReactDOM.render(
		<div className="ms-u-textAlignRight">
			<PrimaryButton data-automation-id="btnFile" text="File" onClick={closeButtonClick} />
		</div>,
		document.getElementById("done")
	);
}
